import { ArrowRight, Phone } from "lucide-react";

export default function FinalCTA({ phone = "[PHONE NUMBER]" }) {
  const go = () => document.getElementById("enquire")?.scrollIntoView({ behavior: "smooth" });
  const tel = (phone || "").replace(/[^0-9]/g, "");
  return (
    <section className="py-24 md:py-32 bg-[#2C392F] text-[#F7F5F0] relative overflow-hidden dark-section">
      <div className="absolute inset-0 grain opacity-50 pointer-events-none" />
      {/* decorative arches */}
      <svg className="absolute -top-20 -right-20 opacity-10" width="380" height="380" viewBox="0 0 200 200">
        <circle cx="100" cy="100" r="98" stroke="#F7F5F0" strokeWidth="0.5" fill="none" />
        <circle cx="100" cy="100" r="74" stroke="#F7F5F0" strokeWidth="0.5" fill="none" />
        <circle cx="100" cy="100" r="50" stroke="#F7F5F0" strokeWidth="0.5" fill="none" />
      </svg>

      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center relative reveal">
        <div className="text-[11px] uppercase tracking-[0.35em] text-[#D89B7E] mb-6">An invitation</div>
        <h2 className="serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tightest font-light">
          Your Dehradun pause <span className="italic text-[#D89B7E]">begins here.</span>
        </h2>
        <p className="mt-8 text-[#F7F5F0]/75 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Come for the quiet, the open space, the home-cooked meals and the comfort of having a place
          entirely your own.
        </p>
        <p className="mt-5 serif italic text-[#D89B7E] text-xl md:text-2xl max-w-2xl mx-auto leading-snug">
          Stay close to the hills, without giving up the comfort of a private home.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="cta-button-final-enquire"
            onClick={go}
            className="inline-flex items-center justify-center gap-2 bg-[#985F47] hover:bg-[#86513A] text-[#F7F5F0] px-8 py-4 rounded-full text-[12px] tracking-[0.2em] uppercase transition-all"
          >
            Enquire About Availability <ArrowRight size={16} />
          </button>
          <a
            data-testid="cta-button-final-call"
            href={tel ? `tel:${tel}` : "#enquire"}
            className="inline-flex items-center justify-center gap-2 border border-[#F7F5F0]/30 hover:bg-[#F7F5F0] hover:text-[#2C392F] text-[#F7F5F0] px-8 py-4 rounded-full text-[12px] tracking-[0.2em] uppercase transition-all"
          >
            <Phone size={16} /> Call ChiMano House
          </a>
        </div>
      </div>
    </section>
  );
}
